import React, { Fragment, useState } from 'react';
import Picture from '../../components/Picture';
import AppRatings from '../AppRatings/AppRatings';

import './HomeSolutionsTabsV6Test.scss';


const TABS = [
  {
    id: 'mercos-ia',
    label: 'Mercos IA',
    icon: '/images/site/icons/ai.svg',
    iconInvert: true,
    overtitle: 'Mercos IA',
    title: 'IA na palma da mão para uma operação mais rápida e inteligente',
    descriptions: [
      (
        <Fragment>
          Com o Mercos IA, a inteligência artificial trabalha junto com a gestão e a equipe comercial, <strong>no sistema, no aplicativo e pelo WhatsApp</strong>. Transforme conversas, imagens, PDFs, áudios ou planilhas em pedidos em segundos, reduzindo tarefas manuais e erros operacionais.
        </Fragment>
      ),
      'Além disso, faça perguntas sobre clientes, vendas e indicadores, gere relatórios personalizados, receba resumos inteligentes de negociações e acompanhe a operação comercial em tempo real.',
    ],
    saibaMaisHref: '/recursos/mercos-ia/',
    image: { src: '/images/site/new-home/v6/tab-mercos-ia.png', alt: 'Conversa no WhatsApp com o Mercos IA, que também atua como assistente de vendas do vendedor, mostrando a criação automática de um orçamento a partir do envio de um arquivo PDF com a lista de pedidos, com link direto para o pedido gerado na plataforma Mercos.' },
    testimonial: {
      quote: (
        <Fragment>
          “O Mercos IA trouxe mais agilidade para nossa operação comercial. Um pedido que antes demorava cerca de 30 minutos para ser lançado agora leva <strong>5 minutos</strong>. Reduzimos em <strong>quase 90%</strong> o tempo desse processo e ganhamos muito mais produtividade, além de consultarmos informações de clientes, pedidos e resultados de forma simples, com uma IA que entende nossa rotina e está integrada ao sistema.”
        </Fragment>
      ),
      author: 'Thiago Bazzo',
      company: 'Pupee Brinquedos',
      avatar: null,
    },
  },
  {
    id: 'forca-de-vendas',
    label: 'Força de Vendas',
    icon: '/images/site/icons/graph.svg',
    overtitle: 'Força de vendas',
    title: 'Venda com agilidade e automatize o controle da rotina comercial',
    descriptions: [
      (
        <Fragment>
          O força de vendas Mercos reúne tudo o que sua equipe comercial precisa para vender com eficiência. A partir dele, conecte CRM, e-commerce B2B, Mercos Pay e integrações para <strong>centralizar a operação comercial em uma única plataforma</strong>.
        </Fragment>
      ),
      'Emita pedidos, automatize processos, gerencie estoque, produtos e clientes, acompanhe equipes e use IA para agilizar a rotina. Além disso, acesse mais de 25 relatórios ou crie indicadores personalizados com IA.',
    ],
    saibaMaisHref: '/forca-vendas/',
    image: { src: '/images/site/new-home/v6/tab-forca-de-vendas.png', alt: 'Dashboard da força de vendas do Mercos com criação de pedidos com IA, carteira de clientes, resumo de resultados e indicadores comerciais que automatizam a rotina e aumentam a produtividade da equipe.' },
    testimonial: {
      quote: '"Evoluímos muito a qualidade dos pedidos, desde a emissão até a entrega. Além disso, integramos o Mercos ao nosso ERP e automatizamos nosso fluxo operacional"',
      author: 'Henrique Zompeiro',
      company: 'Gerente Financeiro na Corsa Bike',
      avatar: '/images/site/depoimentos/henrique-zompeiro-corsa-bike.png',
    },
  },
  {
    id: 'crm',
    label: 'CRM',
    icon: '/images/site/icons/funnel-dark.svg',
    overtitle: 'CRM',
    title: 'Conecte relacionamentos e vendas com um CRM que atua do primeiro pedido ao pós-venda',
    descriptions: [
      'O CRM de Vendas Mercos vai além do tradicional: organiza lembretes, atividades, cadências de contato e alertas de oportunidades em um funil de vendas prático e eficiente, enquanto atua dentro da negociação.',
      'Ele reúne históricos, sugere próximos passos, aplica automaticamente condições comerciais e registra cada interação, garantindo mais agilidade, organização e controle.',
    ],
    saibaMaisHref: '/crm-de-vendas',
    image: { src: '/images/site/new-home/v6/tab-crm.png', alt: 'Funil de vendas do CRM Mercos com etapas Prospecção, Contato, Qualificação, Demostração e Negociação. Exemplo mostra oportunidades como SolarMais (R$ 18.490,00), MaxFrota (R$ 18.340,00) e MaxSocial (R$ 15.000,00), com lembretes, atividades, cadências de contato e alertas de oportunidades organizados automaticamente para maior agilidade e controle na negociação comercial.' },
    testimonial: {
      quote: '"O Mercos transformou o nosso processo comercial. Conseguimos ver quais clientes estão próximos de recomprar, quais estão inativos e onde precisamos expandir, permitindo que o time foque no relacionamento e no crescimento".',
      author: 'Marcos Rogério Scalabrin',
      company: 'Arte Cacau',
      avatar: '/images/site/depoimentos/marcos-rogerio-scalabrin-arte-cacau.png',
    },
  },
  {
    id: 'ecommerce-b2b',
    label: 'E-commerce B2B',
    icon: '/images/site/icons/cart.svg',
    overtitle: 'E-commerce B2B',
    title: 'Mais produtividade e flexibilidade: um canal de vendas online para pedidos a qualquer hora',
    descriptions: [
      'O e-commerce B2B é uma loja virtual onde os clientes fazem pedidos online com autonomia, dentro das políticas comerciais da empresa. Ele reduz a dependência do vendedor para pedidos recorrentes e gera demanda mesmo fora do horário comercial.',
      'Na prática, isso diminui o retrabalho da equipe, amplia oportunidades e oferece um canal de vendas que funciona 24 horas por dia para novos e antigos compradores.',
    ],
    saibaMaisHref: '/e-commerce-b2b/',
    image: { src: '/images/site/new-home/v6/tab-ecommerce-b2b.png', alt: 'E-commerce B2B Mercos com personalização de cores, promoções, destaques e produtos como arroz, açúcar e óleo, com clientes solicitando acesso, oferecendo mais produtividade, flexibilidade e vendas online 24 horas.' },
    testimonial: {
      quote: '"Com o e-commerce B2B, os vendedores focam muito mais na relação com o cliente, em serem os especialistas que ajudam na venda e no pós-venda, do que em resolver as minúcias burocráticas de uma tabela, por exemplo."',
      author: 'Felipe Almeida',
      company: 'HPrime',
      avatar: '/images/site/depoimentos/felipe-almeida-hprime.png',
    },
  },
  {
    id: 'aplicativo',
    label: 'Aplicativo',
    icon: '/images/site/icons/smartphone.svg',
    overtitle: 'Aplicativo',
    title: 'O núcleo de vendas do representante: leve seu escritório no bolso e emita pedidos',
    descriptions: [
      'O aplicativo de vendas é o maior aliado da equipe. É nele que os pedidos são emitidos, mesmo offline, com a ajuda da Inteligência Artificial.',
      'Tudo isso com regras comerciais aplicadas automaticamente, enquanto o representante acompanha cada negociação pela tela, sem papel, planilhas ou retrabalhos. Ideal para vendas, práticas, ágeis e com prioridades claras.',
    ],
    saibaMaisHref: '/recursos/aplicativo-vendas-externas/',
    image: { src: '/images/site/new-home/v6/tab-aplicativo.png', alt: 'Aplicativo Mercos para representantes de indústrias e distribuidoras com lista de pedidos (em orçamento, concluídos e faturados), regras comerciais automáticas e emissão de pedidos com ou sem internet, levando o escritório de vendas no bolso.' },
    testimonial: {
      quote: '"Com o Mercos, deixei de ser um representante para ser uma empresa de representação estruturada. Passamos mais profissionalismo aos olhos dos clientes! Centralizamos os pedidos e, com isso, acessamos dados como o tempo desde a última compra, o estoque disponível e os produtos mais vendidos."',
      author: 'Bruno Barbosa',
      company: 'Barbosa & Colombi Representações',
      avatar: '/images/site/depoimentos/bruno-barbosa-colombi.png',
    },
  },
  {
    id: 'mercos-pay',
    label: 'Mercos Pay',
    icon: '/images/site/icons/card.svg',
    overtitle: 'Mercos Pay',
    title: 'Receba o pagamento dos pedidos direto pelo Mercos com praticidade e segurança',
    descriptions: [
      'O Mercos Pay é a solução financeira desenvolvida pela Mercos que permite que você receba pagamentos por cartão de crédito, boleto ou Pix.',
      'Com ele, os clientes pagam no checkout do e-commerce B2B ou por um link de pagamento gerado pelo representante durante a venda, com cobranças únicas, parceladas, mistas ou até com mais de um cartão. E mais: além das tarifas atrativas, você só paga se receber.',
    ],
    saibaMaisHref: '/mercos-pay/',
    image: { src: '/images/site/new-home/v6/tab-mercos-pay.png', alt: 'Mercos Pay: receba pagamentos de pedidos diretamente no Mercos com praticidade e segurança, aceitando cartão, boleto e Pix, com tarifas atrativas e checkout integrado ao e-commerce B2B.' },
    testimonial: {
      quote: '"Passamos a transacionar 95% do faturamento diretamente pelo sistema com o Mercos Pay, economizando 2 dias de trabalho por mês. Também reduzimos em 10x o tempo de emissão de notas e cobranças com a integração com nosso ERP."',
      author: 'Allan Gomes',
      company: 'La Ganexa',
      avatar: '/images/site/depoimentos/allan-gomes-la-ganexa.png',
    },
  },
];

const HomeSolutionsTabsV6 = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const tab = TABS[activeIndex];

  return (
    <div className="home-solutions-tabs-v6">
      <div className="container">

        {/* Section Header */}
        <div className="header">
          <h3 className="title">
            A solução mais prática, completa e segura para seu negócio
          </h3>
          <p className="description">
            Quando sua operação comercial está em jogo, não há espaço para erros.
            <br />
            Milhares de empresas confiam na tecnologia, anos de experiência e suporte dedicado da Mercos
          </p>
        </div>

        {/* Tab Navigation */}
        <nav className="tab-nav" role="tablist">
          {TABS.map((t, i) => (
            <button
              key={t.id}
              role="tab"
              aria-selected={i === activeIndex}
              className={`tab-btn${i === activeIndex ? ' tab-btn--active' : ''}`}
              onClick={() => setActiveIndex(i)}
            >
              <img
                src={t.icon}
                alt=""
                className={`tab-icon${t.iconInvert ? ' tab-icon--invert' : ''}`}
              />
              <span className="tab-label">{t.label}</span>
            </button>
          ))}
        </nav>

        {/* Tab Content */}
        <div className="tab-content" role="tabpanel">
          <div className="text-col">
            {tab.title ? (
            <h4 className="tab-title">
              <span className="overtitle">{tab.overtitle}</span>
              {tab.title}
            </h4>
          ) : (
            <span className="overtitle">{tab.overtitle}</span>
          )}
            {tab.descriptions.map((desc, i) => (
              <p key={i} className="tab-description">{desc}</p>
            ))}
            {tab.title && (
              <a href={tab.saibaMaisHref} className="saiba-mais" target="_blank" rel="noreferrer">
                saiba mais &rsaquo;
              </a>
            )}
            {!tab.title && (
              <p className="coming-soon">Conteúdo em breve.</p>
            )}
          </div>
          <div className="image-col">
            {tab.image && (
              <Picture
                loading="lazy"
                className="tab-image"
                src={tab.image.src}
                alt={tab.image.alt}
              />
            )}
          </div>
        </div>

        {/* Testimonial */}
        {tab.testimonial && (
          <div className="testimonial">
            <div className="stars">★★★★★</div>
            <p className="quote">{tab.testimonial.quote}</p>
            <div className="author">
              {tab.testimonial.avatar && (
                <Picture
                  src={tab.testimonial.avatar}
                  alt={tab.testimonial.author}
                  className="author-avatar"
                  width={36}
                  height={36}
                />
              )}
              <div className="author-info">
                <p className="author-name">{tab.testimonial.author}</p>
                <p className="author-company">{tab.testimonial.company}</p>
              </div>
            </div>
          </div>
        )}

        {/* App Ratings */}
        <div className="app-ratings-wrapper">
          <AppRatings onlyCards />
        </div>

      </div>
    </div>
  );
};

export default HomeSolutionsTabsV6;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/HomeSolutionsTabs/HomeSolutionsTabsV6Test.jsx